// Mock data for Deslumbrângulo website

export const approaches = [
  {
    id: 'monitoring',
    title: 'Monitorização',
    description: 'Acompanhamento contínuo das infraestruturas',
    icon: 'Activity'
  },
  {
    id: 'control',
    title: 'Controlo',
    description: 'Gestão centralizada de sistemas e equipamentos',
    icon: 'Settings'
  },
  {
    id: 'alerts',
    title: 'Alertas',
    description: 'Notificações sobre eventos relevantes',
    icon: 'Bell'
  },
  {
    id: 'optimization',
    title: 'Otimização',
    description: 'Melhoria da eficiência operacional',
    icon: 'TrendingDown'
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: 'Diagnóstico',
    description: 'Análise das infraestruturas e identificação de necessidades'
  },
  {
    step: 2,
    title: 'Planeamento',
    description: 'Desenho da solução adequada ao contexto'
  },
  {
    step: 3,
    title: 'Implementação',
    description: 'Instalação e integração de sistemas'
  },
  {
    step: 4,
    title: 'Acompanhamento',
    description: 'Suporte técnico e ajustes contínuos'
  }
];
